// extracted by mini-css-extract-plugin
export default {"title":"edit-contact_title__-VhDM","field":"edit-contact_field__4a253","line":"edit-contact_line__NYgIv","content":"edit-contact_content__FObUt"};